import { OptionSelected } from '../../../Select/Select';
import { difference } from 'ramda';
import {  Chip  } from "@mui/material";
import { fetchFieldOptions, postTag } from '../../actions/form';
import { Dispatch } from 'redux';
import { ControlInterface } from 'edocatbase/Form';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { CreatableTest } from '../../../Select';

interface CategoryInterface extends ControlInterface, ReduxComponentInterface {
	formInstanceId: string;
	innerFormInstanceId?: string;
	readOnly: boolean;
}

class Category extends React.PureComponent<CategoryInterface> {
	update = () => {
		const {
			actions,
			name,
			control: { params },
			formInstanceId,
			innerFormInstanceId,
		} = this.props;

		actions.fetchFieldOptions(formInstanceId, params.params, name, innerFormInstanceId);
	};

	componentDidMount() {
		this.update();
	}

	componentDidUpdate(prevProps) {
		//Sometimes (e.g. at document details inline metadata edit) the form isn't unmounted and the only way to distinguish
		//the need to fetch values by their nodeRefs is to compare options length, because in the beginning this component
		//always has empty options.
		if (this.props.options?.length === 0 && prevProps.options.length !== 0) {
			this.update();
		}
	}

	onSelectChange = async (value: OptionSelected[]) => {
		const {
			actions,
			name,
			onChange,
			options,
			formInstanceId,
			innerFormInstanceId,
			control: { params },
		} = this.props;
		const newElement = options ? difference(value, options) : [];
		if (newElement.length > 0) {
			const result = await actions.postTag(
				name,
				{ name: newElement[0].value || newElement[0] },
				formInstanceId,
				innerFormInstanceId
			);
			const newValue = {
				value: result.value.response.nodeRef,
				label: result.value.response.name,
			};
			actions.fetchFieldOptions(formInstanceId, params.params, name, innerFormInstanceId, newValue);
		} else {
			onChange([name], value, true);
		}
	};

	render() {
		const {
			autoFocus,
			disabled,
			label,
			value,
			options,
			mandatory,
			name,
			className,
			placeholder,
			readOnly,
			important,
		} = this.props;

		return (
			<div className={`form-row row-${name}${readOnly ? ' simple-row' : ''}`}>
				{readOnly ? (
					<window.React.Fragment>
						<label>{label}</label>
						<div id={name}>
							{!value || !value.map || value.length === 0
								? window.Alfresco.messages.global['label.none']
								: value.map((item: any, index: number) => (
										<Chip sx={{height: '1.5rem',
											marginRight: '5px'}} key={index} label={item.label} />
								  ))}
						</div>
					</window.React.Fragment>
				) : (
					<CreatableTest
						id={name}
						autoFocus={autoFocus}
						className={className}
						disabled={disabled}
						isClearable={!mandatory}
						label={label}
						mandatory={mandatory}
						multi
						name={name}
						onChange={this.onSelectChange}
						options={options}
						value={value}
						placeholder={placeholder}
						important={important}
					/>
				)}
			</div>
		);
	}
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
	actions: bindActionCreators({ fetchFieldOptions, postTag }, dispatch),
});

export default connect(null, mapDispatchToProps)(Category);
